import React from 'react';
import { Button, Container, Row } from 'react-bootstrap';

export default function NotFound() {
    return(
        <Container 
        className="d-flex align-items-center justify-content-center"
        style = {{ minHeight: "100vh" }}
        >
            <div className="w-100" style = {{ maxWidth: "400px"}}>
                <body>
                    <h1 className="text-center mb-4" style={{fontSize:"4em"}}>Error 404</h1>
                    <h2 className="text-center mb-4">Página no encontrada</h2>
                </body>
                <Row className="justify-content-md-center" xs="auto">
                    <Button href="/">Inicio</Button>
                </Row>
            </div>
        </Container>
    );
}